import { VyneButton, VyneModal } from '@vynedental/design-system'
import React, { FC } from 'react'
import { ObservableBoolean } from '@legendapp/state'

type TinHoldModalProps = {
  tinHolds: string[]
  tinHoldModalConfirmed$: ObservableBoolean
}

export const TinHoldModal: FC<TinHoldModalProps> = ({ tinHolds, tinHoldModalConfirmed$ }) => {

  const handleConfirm = () => {
    tinHoldModalConfirmed$.set(true)
  }

  return (
    <VyneModal
      closable={false}
      dataTestId='tin-hold-modal'
      title='New TIN(s) Detected'
      open={!!tinHolds && !tinHoldModalConfirmed$.get()}
      footer={[
        <VyneButton
          dataTestId='confirm-tin-button'
          key='confirm'
          onClick={handleConfirm}
          type='primary'
        >
          Confirm
        </VyneButton>,
      ]}
    >
      <p>
        We've identified one or more new Tax ID(s) in your latest batch, which
        are not registered to your account.
      </p>
      <p className='mt-050'>
        {' '}
        Please click
        <a
          href='https://calendly.com/rcmconsult/practice-revenue-consultation-vyne?utm_source=inapp'
          target='_blank'
          className='ml-025 mr-025'
          rel='noreferrer'
        >
          <strong>here</strong>
        </a>
        to schedule an account review with your Vyne Dental Practice Revenue
        Advisor, or call us at
        <a
          href='tel:866-712-9584'
          className='ml-025 mr-025'
        >
          866-712-9584
        </a>
        .
      </p>
      <p className='mt-050'>Thank you!</p>
      <div className='mt-100 mb-100'>
        {tinHolds?.map((id: string) => {
          return <p key={id}>{id}</p>
        })}
      </div>
      <p>All claims with the Tax ID(s) listed above will be rejected.</p>
    </VyneModal>
  )
}
